module.exports = __webpack_public_path__ + "static/media/paid-reading.5edd4968.svg";